module.exports = __webpack_public_path__ + "img/logo.aea1f807.png";